import styled, { css } from 'styled-components'

type IsMobileProps = {
  isMobile: boolean
}

export const ContentContainer = styled.div<IsMobileProps>`
  position: relative;

  svg {
    position: absolute;
    bottom: -30px;
    right: -12px;
  }

  ${({ isMobile }) => isMobile && css`
    width: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    svg {
      transform: rotate(124deg) scaleY(-1);
      bottom: -52px;
      right: 94px;
    }
  `}
`

export const TooltipWrapper = styled.div<IsMobileProps>`
  ${({ isMobile }) => isMobile && css`
    position: relative;
    button {
      position: absolute;
      bottom: -96px;
      right: -40px;
    }
  `}
`